import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'MaximumWorkingHoursByDaily',
  props: {
    modelValue: {},
    windowInnerWidth: {},
    errors: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_v_col, { cols: 2 }, null, 512), [
      [_vShow, __props.windowInnerWidth > 800]
    ]),
    _createVNode(_component_v_col, {
      cols: __props.windowInnerWidth > 800 ? 3 : 6
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_text_field, {
          modelValue: modelValue.value.hours,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.hours) = $event)),
          suffix: _unref(i18n).global.t('pages.operationOffices.hours'),
          class: "mt-0",
          density: "compact",
          maxlength: "2",
          "error-messages": __props.errors['settings_monthly_report.over_time_thresholds.daily.hours']
        }, null, 8, ["modelValue", "suffix", "error-messages"])
      ]),
      _: 1
    }, 8, ["cols"]),
    _createVNode(_component_v_col, {
      cols: __props.windowInnerWidth > 800 ? 3 : 6
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_text_field, {
          modelValue: modelValue.value.minutes,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.minutes) = $event)),
          suffix: _unref(i18n).global.t('pages.operationOffices.minutes'),
          class: "mt-0",
          density: "compact",
          maxlength: "2",
          "error-messages": __props.errors['settings_monthly_report.over_time_thresholds.daily.minutes']
        }, null, 8, ["modelValue", "suffix", "error-messages"])
      ]),
      _: 1
    }, 8, ["cols"])
  ], 64))
}
}

})